import { useState, useEffect } from 'react';

import { CommonDataContext } from './CommonDataContext';
import { PublicApi } from 'api/api';

const publicApi = new PublicApi();


// import { hasPermission } from 'utility/accessibility/hasPermission';

export const CommonDataProvider = ({ children }) => {
  const [commonData, setCommonData] = useState({
   countries : []
  });

  useEffect(() => {
    const fetchCommonData = async () => {
      setCommonData((prev) => ({ ...prev, isLoading: true }))
      try {
        const [
          // languagesResponse,
          countries,
        
          // userGroupsResponse,
        ] = await Promise.all([
          // languagesApi.apiLanguagesForUiGet(),
          publicApi.apiPublicGetAllCountry(),
         
        ]);

        setCommonData({

          countries: countries?.data,
    
        });

      } catch (error) {
        console.error(error);
      } finally {
        setCommonData((prev) => ({ ...prev, isLoading: false }))
      }
    };

    fetchCommonData();
  }, []);

  return (
    <CommonDataContext.Provider value={commonData}>
      {children}
    </CommonDataContext.Provider>
  );
};
